import React from 'react';
import styled from "styled-components"
<style>
    @import url('https://fonts.googleapis.com/css2?family=Anton&family=Bebas+Neue&family=Dancing+Script:wght@500;700&family=Montserrat:wght@200;300;400&family=Poppins&family=Questrial&family=Quicksand:wght@300&family=Roboto:wght@300&family=Suez+One&display=swap');
</style>

function FoundersBg() {
    return (
        <Wrapper>
           
        </Wrapper>
    );
}

export const Wrapper = styled.div`
  background-image: url('./img/partnership.png');
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  height: 760px;
`

export default FoundersBg;